import { Image, Text, View } from 'components';
import Base, { Config } from 'components/trunk/Base';
import { history } from 'modules/navigator';
import { ToastContainer, toast } from 'react-toastify';
import React from 'react';
import styles from './index.module.scss';

interface RechargeOption {
  id: number;
  value: number; // 积分
  gift: number; //赠送积分
  price: string; // 价格
  origin_price: string; // 原价
  info: string
}

interface State {
  userinfo?: any
  options: RechargeOption[];
  selectOptionId: number;
  scores?: number;
  AdList?: any[]
}

export default class ScoresRecharge extends Base<any, State> {
  public config: Config = {
    navigationBarTitleText: '积分充值'
  };

  public state: State = {
    options: [],
    selectOptionId: 0,

  };

  public async didMount() {
    this.getUserInfo()
    await this.fetchScores();
    this.fetchRechargeList();
    this.getAdLists()
  }

  public render() {
    const { userinfo, options, selectOptionId, scores, AdList } = this.state;

    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>

        <View className={styles.redBox}>
          {userinfo && 
            <View className={styles.header}>
              <Image src={userinfo.avatar || ''} className={styles.avatar} />
              <Text className={styles.h2}>
                {userinfo.nickname || ''}
                <Text className={styles.sm}>（剩余积分：
                  <Text className={styles.yellow}>{scores}</Text>
                ）</Text>
              </Text>
            </View>
          }
          <View className={styles.alermBox}>
            <View className={styles.tip}>
              <Image
                className={styles.adIco}
                src={this.assets.trunk.trumpetO}
              />
              <Text className={styles.txt}>请购买积分或加入会员，拨打货源电话</Text>
            </View>
          </View>
          <View className={styles.lists}>
            {options.map((res, ind) => (
              <View key={res.id} className={this.cx(styles.lis, {
                [styles.active]: selectOptionId == res.id
              })} onClick={this.handleSelectOption.bind(this, res)}>
                <View className={styles.itemBox}>
                  {(Number(res.price) < Number(res.origin_price)) && 
                    <View className={styles.tag}>限时优惠</View>
                  }
                  {ind == 1 && 
                    <View className={styles.recommend}>推荐</View>
                  }
                  <View className={styles.itemL}>
                    <Text className={styles.h2}>{res.value-res.gift}积分
                      <Text className={styles.red}>+赠送{res.gift}积分</Text>
                    </Text>
                  </View>
                  <View className={styles.itemR}>
                    <View className={styles.rInner}>
                      <Text className={styles.p}>￥
                        <Text className={styles.b}>{parseInt(res.price)}</Text>
                      </Text>
                      <Text className={styles.p}>{"购买>>"}</Text>
                    </View>
                  </View>
                </View>
              </View>
            ))}
          </View>
          <View className={styles.adListBox}>
            {AdList && AdList.map((ad, ind) => (
              <Image 
                className={styles.adImg} 
                onClick={() => {
                  if(ad.path.plat == 'wp' && ad.path.path) {
                    window.location.href=ad.path.path
                  }else {
                    toast.success("请前往51板车小程序查看",{
                      position: toast.POSITION.TOP_RIGHT,
                      autoClose: 2500,
                      closeButton: false,
                    })
                  }
                }} 
                src={ad.url} 
              />
            ))}
          </View>
        </View>
        
        <View className={styles.ruleBox}>
          <View className={styles.ruleInner}>
            <Text className={styles.tit}>
              <Text className={styles.txt}>积分规则</Text>
            </Text>
            <View className={styles.ul}>
              <View className={styles.li}>1、打货源电话消耗10积分/次</View>
              <View className={styles.li}>2、虚拟积分不支持退换和转让，请确认后购买！</View>
              <View className={styles.li}>3、支付遇到问题？
                <View className={styles.a} onClick={() => {
                  this.navigator.push("advice")
                }}>{'点此求助>>'}</View>
              </View>
            </View>
          </View>
        </View>




      </View>
    );
  }

  private handlePurchase = async () => {
    const mob = await this.store.user.requireMobile()
    if(!mob) {
      return;
    }
    
    const response = await this.apiClient.base.purchaseScores({
      id: this.state.selectOptionId
    });

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        alert('充值成功');

        

        this.fetchScores();
      }
    });
  }



  private fetchScores = async () => {

    const { body } = await this.apiClient.base.account();

    if (!body) {
      return;
    }

    this.setState({
      scores: body.score
    });
  }
  private getUserInfo = async () => {
    const { body } = await this.apiClient.base.userinfo();

    this.setState({
      userinfo:body
    })

    // this.setState({
    //   userinfo: {"id":2,"nickname":"\u6211\u8ba4\u8bc6\u4f60","realname":"","mobile":"15267286145","mobile_location":"\u6d59\u6c5f\u53f0\u5dde(\u79fb\u52a8)","avatar":"https:\/\/assets.gongji58.com\/2019-02-27\/clavmj717r1551257843.png!medium","sex":1,"type":1,"reg_ip":"223.104.246.162","point":0,"id_number":"","address":"","address_id":null,"description":"","store_name":"\u6211\u8ba4\u8bc6\u4f60","store_description":"\u6d4b\u8bd5\u4e2a\u5443\u5443\u5443","car_total":54,"want_total":3,"job_total":12,"resume_total":11,"report_total":1,"last_login":"2021-06-11 11:40:54","ban_desc":"","developer":1,"status":3,"ctime":"2019-02-27 16:57:23","utime":"2020-09-15 11:38:48","is_manager":true,"id_checks":false,"pub_total":0}
    // })
  }

  private fetchRechargeList = async () => {
    const { body: options } = await this.apiClient.base.scoresRechargeList();

    this.setState({
      options,
      selectOptionId: (options.find(option => !!option.selected) || {}).id || 0
    });
  }

  private handleSelectOption = res => {
    this.setState({
      selectOptionId: res.id
    }, () => {
			this.handlePurchase()
		});
  }

  private get selectedOption() {
    const { selectOptionId, options } = this.state;
    let res:any = options.find(option => option.id == selectOptionId) || {}
    return res;
  }


  private getAdLists = async() => {
    const { body } = await this.apiClient.base.ad({
      page: 'pages/score/index',
      type: 1  //1图片 2视频
    })

    this.setState({
      AdList: body || []
    })
  }
}
